'use strict';

// import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';

import { layer } from './plugins/layer/index.js';

import Lenis from 'lenis';

// import Splide from '@splidejs/splide';
// import '@splidejs/splide/css';

// import { checkAutoplaySupport } from './utiles/index.js'

import LazyLoad from 'vanilla-lazyload';

// AOS
// import AOS from 'aos';
// import 'aos/dist/aos.css'

// import * as CookieConsent from 'vanilla-cookieconsent';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';

import SimpleShare from './plugins/simpleshare/index.js';

import JustValidate from 'just-validate';

import EmblaCarousel from 'embla-carousel';
import EmblaAutoplay from 'embla-carousel-autoplay';
import AutoScroll from 'embla-carousel-auto-scroll';
import ClassNames from 'embla-carousel-class-names';
import EmblaFade from 'embla-carousel-fade';
import EmblaAutoHeight from 'embla-carousel-auto-height';

import { addEmblaDotClickHandlers, addEmblaPrevNextClickHandlers, addDotBtnsAndClickHandlers } from './plugins/EmblaCarouselFeatures.js';

import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.js';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import Choices from 'choices.js';
import 'choices.js/src/styles/choices';

import Cookies from 'js-cookie';

import { checkViewTransition, checkAutoplaySupport } from './utiles/index.js';

import axios from 'axios';

// import * as THREE from 'three';

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

import './iconfont/iconfont.js';

// Initialize Lenis
const lenis = new Lenis();

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

document.addEventListener('DOMContentLoaded', () => {
	const btnOpenSearch = document.querySelector('.js-open-search');
	const headerSearchNode = document.querySelector('.header-search');
	btnOpenSearch.addEventListener('click', () => {
		headerSearchNode.classList.add('active');
	});

	const hmLinks = document.querySelectorAll('.hm-link');
	hmLinks.forEach((hmlink, index) => {
		// console.log(hmlink);
		const hmsub = hmlink.closest('.hm-li').querySelector('.hm-sub');
		if (hmsub) {
			// console.log(hmsub);
			if (hmsub.querySelector('.current')) {
				// console.log('ssss');
				hmlink.classList.add('parents');
			}
		}
	});

	const btnToggleHeaderMenu = document.querySelector('.js-toggle-header-menu');
	btnToggleHeaderMenu.addEventListener('click', () => {
		document.body.classList.toggle('menu-open');
	});

	// Index
	const ibViewportNode = document.querySelector('.embla-ibanner__viewport');
	if (ibViewportNode) {
		const options = {
			loop: true,
			align: 'start',
		};
		const autoplay = EmblaAutoplay({ stopOnInteraction: false, delay: 4000 });
		const emblaApi = new EmblaCarousel(ibViewportNode, options, [autoplay]);

		const dots = document.querySelectorAll('.embla-ibanner__dots button');
		addEmblaDotClickHandlers(emblaApi, dots);

		const ibVideos = document.querySelectorAll('.index-banner__video');

		const checkHasVideo = () => {
			const selectedIndex = emblaApi.selectedScrollSnap();
			const slides = emblaApi.slideNodes();
			const currentSlide = slides[selectedIndex];
			const video = currentSlide.querySelector('video');
			if (video) {
				try {
					video.pause();
				} catch {}
				video.currentTime = 0;
				video.play().catch(() => {});
				autoplay.stop();
				console.log('stop play');
			} else {
				console.log('no video');
			}
		};
		emblaApi.on('init', checkHasVideo).on('select', checkHasVideo).on('reInit', checkHasVideo);

		if (ibVideos.length) {
			ibVideos.forEach((v) => {
				v.addEventListener('ended', () => {
					autoplay.play();
				});
			});

			const changeIbVideoPoster = () => {
				let autoplay = true;
				checkAutoplaySupport().then((result) => {
					autoplay = result;
					ibVideos.forEach((v) => {
						if (autoplay) {
							v.removeAttribute('controls');
						} else {
							v.setAttribute('controls', 'controls');
						}
					});
				});

				ibVideos.forEach((v) => {
					v.setAttribute('poster', window.innerWidth > 767 ? v.getAttribute('data-poster-pc') : v.getAttribute('data-poster-m'));

					if (autoplay) {
						v.removeAttribute('controls');
					} else {
						v.setAttribute('controls', 'controls');
					}
				});
			};
			window.addEventListener('resize', () => {
				changeIbVideoPoster();
			});
			changeIbVideoPoster();
		}
	}

	const iproductsNode = document.querySelector('.embla-iproduct__viewport');
	if (iproductsNode) {
		const emblaApi = new EmblaCarousel(iproductsNode, { loop: true }, [EmblaAutoplay({ playOnInit: true }), ClassNames()]);
	}

	const iprocessNode = document.querySelector('.embla-iprocess__viewport');
	if (iprocessNode) {
		const emblaApi = new EmblaCarousel(iprocessNode, { loop: true }, [EmblaAutoplay({ playOnInit: true })]);
		const dotsNode = iprocessNode.querySelector('.embla__dots');

		const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
		emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
	}

	const clubViewportNode = document.querySelector('.embla-club__viewport');
	if (clubViewportNode) {
		const emblaApi = new EmblaCarousel(clubViewportNode, {}, [EmblaAutoplay({ playOnInit: true })]);
		const dotsNode = clubViewportNode.querySelector('.embla__dots');

		const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
		emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
	}

	const inumViewportNode = document.querySelector('.embla-inum__viewport');
	if (inumViewportNode) {
		const emblaApi = new EmblaCarousel(inumViewportNode, {}, [EmblaAutoplay({ playOnInit: true })]);
		const dotsNode = inumViewportNode.querySelector('.embla__dots');

		const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
		emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
	}

	const irecomNode = document.querySelector('.embla-irecom__viewport');
	if (irecomNode) {
		const options = {
			loop: true,
			align: 'start',
		};
		const plugins = [EmblaAutoplay({ playOnInit: true })];
		const emblaApi = new EmblaCarousel(irecomNode, options, plugins);
	}

	if (document.querySelector('.js-index-process')) {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.js-index-process',
				start: 'top center',
				end: 'top top',
				scrub: 1,
			},
		});
		tl.addLabel('start');
		tl.to('.js-index-bg1', { opacity: 0 }, 'start');
		tl.to('.js-index-bg2', { opacity: 1 }, 'start');
	}

	// About
	const aboutAViewportNode = document.querySelector('.embla-abouta__viewport');
	if (aboutAViewportNode) {
		const options = {
			loop: true,
			align: 'start',
		};
		const plugins = [EmblaAutoplay({ playOnInit: false })];
		const emblaApi = new EmblaCarousel(aboutAViewportNode, options, plugins);

		const dots = document.querySelectorAll('.embla-abouta__dots button');

		const btnPrev = document.querySelector('.embla-abouta__prev');
		const btnNext = document.querySelector('.embla-abouta__next');

		addEmblaDotClickHandlers(emblaApi, dots);

		addEmblaPrevNextClickHandlers(emblaApi, btnPrev, btnNext);
	}
	const btnShowMoer = document.querySelector('.js-show-more');
	if (btnShowMoer) {
		btnShowMoer.addEventListener('click', () => {
			btnShowMoer.closest('.show-more-box').classList.toggle('show');
		});
	}

	// About Craft
	const emblaCraftNode = document.querySelector('.embla-craft__viewport');
	if (emblaCraftNode) {
		const options = {
			loop: true,
			align: 'start',
			startIndex: 2,
		};
		const plugins = [EmblaAutoplay({ playOnInit: false }), EmblaFade()];
		const emblaApi = new EmblaCarousel(emblaCraftNode, options, plugins);

		const dots = document.querySelectorAll('.embla-craft__buttons button');

		addEmblaDotClickHandlers(emblaApi, dots);

		const emblaCraftContentNode = document.querySelector('.embla-craft-content__viewport');
		const emblaConApi = new EmblaCarousel(emblaCraftContentNode, { watchDrag: false }, [EmblaFade(), ClassNames()]);

		const syncEmbla = () => {
			const selectedIndex = emblaApi.selectedScrollSnap();
			emblaConApi.scrollTo(selectedIndex);
		};
		emblaApi.on('select', syncEmbla);
		syncEmbla();
	}

	// About History
	const emblaHistoryNode = document.querySelector('.embla-history__viewport');
	if (emblaHistoryNode) {
		const options = {
			// loop: true,
			align: 'start',
			axis: 'y',
			containScroll: 'keepSnaps',
			dragFree: false,
		};

		const getOptionsByScreen = () => {
			const w = window.innerWidth;
			if (w < 768) {
				return {
					loop: false,
					align: 'start',
				};
			} else {
				return {
					align: 'start',
					axis: 'y',
					containScroll: 'keepSnaps',
					dragFree: false,
				};
			}
		};

		const plugins = [EmblaAutoplay({ playOnInit: false }), ClassNames()];
		let emblaApi = new EmblaCarousel(emblaHistoryNode, getOptionsByScreen(), plugins);

		window.addEventListener('resize', () => {
			emblaApi.destroy();
			emblaApi = new EmblaCarousel(emblaHistoryNode, getOptionsByScreen(), plugins);
		});

		const emblaHistoryConNode = document.querySelector('.embla-history-con__viewport');
		const emblaConApi = new EmblaCarousel(emblaHistoryConNode, getOptionsByScreen());

		const syncEmbla = () => {
			// const selectedIndex = emblaConApi.selectedScrollSnap();
			// updateSlidesClass(selectedIndex);
		};

		// emblaConApi.on('select', updateEmblaHeight);

		const slides = emblaApi.slideNodes();
		let currentIndex = 0;
		const len = slides.length;
		let intv = null;

		// const historyContainer = document.querySelector('.embla-history-con__container');
		// const conSlides = document.querySelectorAll('.embla__slide-hcon');

		const updateSlidesClass = (index) => {
			currentIndex = index;
			emblaApi.scrollTo(index, false);
			emblaConApi.scrollTo(index, false);
			// // emblaConApi.scrollTo(index, false);
			// if (window.innerWidth > 767) {
			// 	// historyContainer.style.transform = `translate3d(0px, -${historyContainer.clientHeight * index}px, 0px)`;
			// } else {
			// 	// historyContainer.style.transform = `translate3d(-${historyContainer.clientWidth * index}px, 0px, 0px)`;
			// 	// conSlides.forEach((conSlide, i) => {
			// 	// 	conSlide.classList.toggle('is-active', i === index);
			// 	// });
			// }

			slides.forEach((slide, i) => {
				slide.classList.toggle('is-active', i === index);
			});
		};
		updateSlidesClass(0);

		slides.forEach((slide, i) => {
			slide.addEventListener('click', () => {
				currentIndex = i;
				updateSlidesClass(i);
				if (intv) {
					clearInterval(intv);
				}
			});
		});

		const btnPrev = document.querySelector('.about-history__prev');
		const btnNext = document.querySelector('.about-history__next');
		btnPrev.addEventListener('click', () => {
			currentIndex = (currentIndex - 1 + len) % len;
			updateSlidesClass(currentIndex);
			if (intv) {
				clearInterval(intv);
			}
		});
		btnNext.addEventListener('click', () => {
			currentIndex = (currentIndex + 1) % len;
			updateSlidesClass(currentIndex);
			if (intv) {
				clearInterval(intv);
			}
		});

		intv = setInterval(() => {
			currentIndex = (currentIndex + 1) % len;
			updateSlidesClass(currentIndex);
		}, 5000);

		const emblaHistorySubNodes = document.querySelectorAll('.embla-history-s__viewport');
		emblaHistorySubNodes.forEach((sub) => {
			const emblaHApi = new EmblaCarousel(sub, { loop: true, axis: 'x' }, [EmblaAutoplay({ playOnInit: true })]);
			const dots = sub.closest('.embla').querySelectorAll('.embla-history__dots button');
			addEmblaDotClickHandlers(emblaHApi, dots);
		});
	}

	// Online Store
	const emblaStoreNode = document.querySelector('.embla-store__viewport');
	if (emblaStoreNode) {
		const options = {
			loop: true,
			align: 'start',
		};
		const plugins = [EmblaAutoplay({ playOnInit: true })];
		const emblaApi = new EmblaCarousel(emblaStoreNode, options, plugins);

		const dots = document.querySelectorAll('.embla-store__dots button');
		addEmblaDotClickHandlers(emblaApi, dots);
	}
	const btnJoinus = document.querySelector('.js-show-joinus');
	if (btnJoinus) {
		const layerJoinus = document.querySelector('.layer-joinus');
		btnJoinus.addEventListener('click', () => {
			checkViewTransition(() => {
				layerJoinus.classList.remove('hidden');
			});
		});

		document.querySelector('.js-close-layer-joinus').addEventListener('click', () => {
			checkViewTransition(() => {
				layerJoinus.classList.add('hidden');
			});
		});
	}

	// About Honor
	const emblaHonorNode = document.querySelector('.embla-honor__viewport');
	if (emblaHonorNode) {
		const options = {
			loop: true,
			align: 'start',
		};
		const plugins = [EmblaAutoplay({ playOnInit: true })];
		const emblaApi = new EmblaCarousel(emblaHonorNode, options, plugins);

		const dots = document.querySelectorAll('.embla-honor__dots button');
		addEmblaDotClickHandlers(emblaApi, dots);
	}

	const choicesElms = document.querySelectorAll('.js-choices');
	if (choicesElms.length) {
		choicesElms.forEach((item, index) => {
			const p = item.getAttribute('aria-placeholder');
			new Choices(item, {
				closeDropdownOnSelect: true,
				searchPlaceholderValue: '搜索',
				searchEnabled: false,
			});
		});
	}

	// Filter Stores
	const choicesProvice = document.querySelector('.js-select2-province');
	const choicesCity = document.querySelector('.js-select2-city');
	const storeListBox = document.querySelector('.js-stores-list');
	let proviceChoices;
	let cityChoices;
	const getStoresData = (type) => {
		let url = location.pathname;
		let cityValue = '';
		const provinceValue = choicesProvice.options[choicesProvice.selectedIndex].value;
		url += `?province=${provinceValue}`;
		if (type === 'city') {
			cityValue = choicesCity.options[choicesCity.selectedIndex].value;
			url += `&city=${cityValue}`;
		}
		console.log(provinceValue, cityValue, url);

		axios.get(url).then((res) => {
			// console.log(res);
			const html = res.data;
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const storeList = doc.querySelector('.js-stores-list').innerHTML;
			const cityList = doc.querySelector('.js-select2-city').innerHTML;
			if (storeList) {
				console.log(storeList);
				storeListBox.innerHTML = storeList;
			}
			if (cityList) {
				cityChoices.destroy();
				choicesCity.innerHTML = cityList;
				cityChoices = new Choices(choicesCity, {
					searchEnabled: false,
					noChoicesText: '暂无选项',
				});
			}
		});
	};
	if (choicesProvice) {
		proviceChoices = new Choices(choicesProvice, {
			searchEnabled: false,
		});
		cityChoices = new Choices(choicesCity, {
			searchEnabled: false,
			noChoicesText: '暂无选项',
		});
		choicesProvice.addEventListener('change', (event) => {
			// console.log('选中值变了:', event.target.value);
			getStoresData('provice');
		});
		choicesCity.addEventListener('change', (event) => {
			// console.log('选中值变了:', event.target.value);
			getStoresData('city');
		});
	}

	// Products
	const btnAntiFake = document.querySelector('.js-btn-antifake');
	if (btnAntiFake) {
		const layerAntiFake = document.querySelector('.layer-antifake');
		btnAntiFake.addEventListener('click', () => {
			checkViewTransition(() => {
				layerAntiFake.classList.remove('hidden');
			});
		});
		document.querySelector('.js-close-antifake').addEventListener('click', () => {
			checkViewTransition(() => {
				layerAntiFake.classList.add('hidden');
			});
		});

		document.addEventListener('click', (e) => {
			if (e.target.classList.contains('js-toggle-prod-awrads')) {
				const wrap = e.target.closest('.prod-awards');
				const box = wrap.querySelector('.prod-awards__list');
				console.log(box.scrollHeight);

				if (wrap.classList.contains('show')) {
					wrap.classList.remove('show');
					box.style.height = '56px';
				} else {
					wrap.classList.add('show');
					box.style.height = `${box.scrollHeight}px`;
				}

				// checkViewTransition(() => {
				// 	e.target.closest('.prod-awards').classList.toggle('show');
				// });
			}
		});
	}

	// Product Loading

	function isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	}
	const btnProdLoading = document.querySelector('.js-prodcuts-loading');
	if (btnProdLoading) {
		let currentPage = 1;
		const countPage = btnProdLoading.getAttribute('data-page-count');
		let url = location.pathname + '?pagenum=';
		let isLoading = true;
		const prodcutsListBox = document.querySelector('.js-products-list');

		// console.log(currentPage, countPage, url, isLoading);
		window.addEventListener('scroll', () => {
			console.log(currentPage < countPage);
			if (currentPage < countPage && isLoading) {
				// console.log('kkk');
				if (isElementInViewport(btnProdLoading)) {
					currentPage++;
					isLoading = false;
					axios.get(url + currentPage).then((res) => {
						// console.log(res);
						const html = res.data;
						const parser = new DOMParser();
						const doc = parser.parseFromString(html, 'text/html');
						const productsList = doc.querySelector('.js-products-list').innerHTML;
						if (productsList) {
							// console.log(productsList);
							prodcutsListBox.innerHTML += productsList;
						}
						isLoading = true;
					});
				}
			} else {
				btnProdLoading.classList.add('hidden');
			}
		});
	}

	// charities
	const emblaCharities = document.querySelector('.embla-charities__viewport');
	if (emblaCharities) {
		const emblaApi = new EmblaCarousel(emblaCharities, { align: 'end' });
		const slides = emblaApi.slideNodes();
		let currentIndex = 0;
		// console.log(slides);
		const container = document.querySelector('.embla-charities__container');

		const charitiesListBox = document.querySelector('.js-list-charities');
		let isInit = false;

		const getCharitiesData = (url) => {
			axios.get(url).then((res) => {
				// console.log(res);
				const html = res.data;
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');
				const charitiesList = doc.querySelector('.js-list-charities').innerHTML;
				// console.log(charitiesList);
				if (charitiesList) {
					// console.log(charitiesList);
					charitiesListBox.innerHTML = charitiesList;
				} else {
					charitiesListBox.innerHTML = '';
				}
			});
		};

		const updateSlidesClass = (index) => {
			currentIndex = index;
			emblaApi.scrollTo(index, false);
			const w = slides[0].clientWidth;
			container.style.setProperty('--progress-width', `${index * w + w / 2}px`);
			slides.forEach((slide, i) => {
				slide.classList.toggle('is-active', i === index);
			});
			const url = slides[index].getAttribute('data-url');
			// console.log(url);
			if (isInit) {
				getCharitiesData(url);
			} else {
				isInit = true;
			}
		};

		slides.forEach((slide, i) => {
			slide.addEventListener('click', () => {
				currentIndex = i;
				// console.log(currentIndex);
				updateSlidesClass(i);
			});
		});

		updateSlidesClass(0);
	}

	// Join Us Form
	const joinUsFormNode = document.getElementById('joinusForm');
	if (joinUsFormNode) {
		const validate = new JustValidate(joinUsFormNode);
		const postURL = joinUsFormNode.getAttribute('action');
		validate
			.addField('.jform_name', [{ rule: 'required', errorMessage: '请输入姓名' }])
			.addField('.jform_phone', [
				{ rule: 'required', errorMessage: '请填写手机号' },
				{ rule: 'customRegexp', value: /^1[3-9]\d{9}$/, errorMessage: '请输入有效的手机号' },
			])
			.addField('.jform_email', [
				{ rule: 'required', errorMessage: '请输入邮箱' },
				{ rule: 'email', errorMessage: '请输入有效的邮箱' },
			])
			.addField('.jform_theme', [{ rule: 'required', errorMessage: '请选择主题' }])
			.addField('.jform_content', [{ rule: 'required', errorMessage: '请填写详细内容' }])
			.onSuccess((event) => {
				console.log('success');

				const formData = new FormData(joinUsFormNode);
				const serializedData = new URLSearchParams(formData).toString();

				// console.log(serializedData);

				axios
					.post(postURL, serializedData)
					.then(function (res) {
						// console.log(res);
						if (res.status == '200') {
							layer.msg(res.data.msg);
							setTimeout(() => {
								checkViewTransition(() => {
									// console.log('hidden');
									// console.log(layerJoinus);
									document.querySelector('.layer-joinus').classList.add('hidden');
									joinUsFormNode.reset();
								});
							}, 2000);
						} else {
							layer.msg(res.data.msg);
						}
					})
					.catch(function (err) {
						console.log(err);
					});
			});
	}

	// const emblaHistoryNode = document.querySelector('.embla-history');
	// if (emblaHistoryNode) {
	// 	const options = {
	// 		loop: true,
	// 		align: 'start',
	// 	};
	// 	const plugins = [EmblaAutoplay({ playOnInit: true })];
	// 	const emblaHistory = new EmblaCarousel(emblaHistoryNode, options, plugins);
	// }
	// 测试用
	// const domLoop = document.querySelectorAll('[data-loop]');
	// if (domLoop) {
	// 	domLoop.forEach((item) => {
	// 		const len = item.getAttribute('data-loop');
	// 		const sourceItem = item.innerHTML;
	// 		for (let i = 0; i < len; i++) {
	// 			item.innerHTML += sourceItem;
	// 		}
	// 	});
	// }

	// Init
	(() => {
		const overAgeNode = document.querySelector('.layer-overage');

		const isOverAge = Cookies.get('overage');

		if (overAgeNode) {
			const btnOverAgeYes = document.querySelector('.js-overage-yes');
			const btnOverAgeNo = document.querySelector('.js-overage-no');

			if (!isOverAge) {
				checkViewTransition(() => {
					lenis.stop();
					overAgeNode.classList.remove('hidden');
				});
			}

			btnOverAgeYes.addEventListener('click', () => {
				checkViewTransition(() => {
					overAgeNode.classList.add('hidden');
					Cookies.set('overage', true, { expires: 30 });
					lenis.start();
				});
			});

			btnOverAgeNo.addEventListener('click', () => {
				location.href = 'about:blank';
			});
		}

		AOS.init({
			duration: 1800,
			offset: 40,
			once: true,
			easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
		});

		Fancybox.bind('[data-fancybox]', {
			// Your custom options
		});

		const myLazyLoad = new LazyLoad({
			threshold: 800,
		});
		// AOS.init({
		// 	duration: 800,
		// 	offset: 40,
		// 	once: true
		// });
		// Social Share
		const share = new SimpleShare({
			url: '',
			title: '',
			content: '',
			pic: '',
		});
		const shareLinks = document.querySelectorAll('[data-share]');
		shareLinks.forEach((link) => {
			link.addEventListener('click', () => {
				share.goShare(link.getAttribute('data-share'));
			});
		});
	})();
});
